module.exports = __webpack_public_path__ + "static/image-varna-food-tours-cb3f351176a20680c3872a983ea6ee05.jpg";